/*
 * Ce se vede cand un ecran cade in randare.
 *
 * Fara asta, o singura exceptie intr-o componenta goleste tot documentul:
 * React demonteaza arborele si ramane <div id="root"> gol. Din afara arata ca o
 * pagina care nu s-a incarcat, iar cine se uita n-are cum sa deosebeasca asta
 * de o cerere care n-a raspuns - doua cauze foarte diferite, acelasi ecran alb.
 *
 * Mesajul se arata pe ecran, nu doar in consola: cine testeaza nu are consola
 * deschisa, si primul lucru pe care il raporteaza e "pagina e goala".
 */

import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { t } from '../lib/i18n';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    /* Si in consola, cu tot cu locul din arbore - acolo se uita cine repara. */
    console.error('Screen crashed:', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="panel" style={{ margin: '2rem auto', maxWidth: '40rem' }}>
        <h2 className="panel__title">{t('This screen could not be displayed')}</h2>
        <p className="prose">
            {t('Something in the page failed while drawing it. The request itself may have gone through — check the list before sending it again.')}
          </p>
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            fontSize: '0.8125rem',
            overflowX: 'auto',
          }}
        >
          {this.state.error.message}
        </pre>
        <button type="button" className="btn" onClick={() => window.location.reload()}>{t('Reload')}</button>
      </div>
    );
  }
}
